import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

function smsSubscribe(phoneNumber) {
    let url = '/api/util/OptinEmailSms';
    const { enableProfileAccountGroup = false } = Sephora.configurationSettings;

    if (enableProfileAccountGroup && cookieUtils.isRCPAccountAPIEnabled()) {
        url = '/gway/v2/util/OptinEmailSms';
    }

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({
                phoneNumber,
                type: 'SMS'
            })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default smsSubscribe;
